module.exports = __webpack_public_path__ + "img/senior-superlative-web.0823ab17.png";